import React from "react";
import useQuery from "../hooks/use-query";
import DebugErrorScreen from "./DebugErrorScreen";

export default function Error() {
  let query = useQuery();
  const errorMsg = query.get("errorMsg") || "Something went wrong";
  return (
    <div style={{ position: "relative", height: "100vh" }}>
      <DebugErrorScreen
        title="Error"
        error={errorMsg}
        details={{
          route: "/error",
          url: window?.location?.href,
          query: Object.fromEntries(new URLSearchParams(window?.location?.search || "")),
        }}
        allowDismiss={false}
      />
    </div>
  );
}
